<h2 mat-dialog-title style="color: #0061A2">
    {{title}}
</h2>
<form [formGroup]="newVisit" fxFlexLayout="column" style="width: 100%; margin: 20px 0px;" (ngSubmit)="onConfirm()" autocomplete="off">
    <div mat-dialog-content fxLayout="column">
        <div fxFlex='100'>
            <mat-form-field appearance="outline">
                <mat-label>Fecha</mat-label>
                <input matInput [min]='minDate' [matDatepicker]="picker1" formControlName="dateActivity">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-error id="required" *ngIf="newVisit.controls['dateActivity'].hasError('required')">
                    La fecha es
                    <strong>requerida</strong>
                </mat-error>
            </mat-form-field>
        </div>
        <div fxFlex="100" fxLayout="row">
            <div fxFlex="24.9">
                <mat-form-field appearance="outline" style="width: 99%;">
                    <mat-label>Jornada</mat-label>
                    <mat-select formControlName="timeDayActivity">
                        <mat-option *ngFor="let timeDayActivity of timeDayList" [value]="timeDayActivity.id">
                            {{timeDayActivity.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error id="required" *ngIf="newVisit.controls['timeDayActivity'].hasError('required')">
                        La jornada es
                        <strong>requerida</strong>
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="74.9">
                <mat-form-field appearance="outline" style="width: 99%;">
                    <mat-label>Cliente</mat-label>
                    <mat-select formControlName="clientActivity">
                        <mat-option *ngFor="let clientActivity of clientActivityList" [value]="clientActivity.id">
                            {{clientActivity.name }} ({{clientActivity.reason}})
                        </mat-option>
                    </mat-select>
                    <mat-error id="required" *ngIf="newVisit.controls['clientActivity'].hasError('required')">
                        El cliente es
                        <strong>requerido</strong>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div fxFlex="100" fxLayout="row">
            <mat-form-field appearance="outline" style="width: 99%;">
                <mat-label>Descripción</mat-label>
                <textarea matInput placeholder="Descripción de la visita..."
                    formControlName="descriptionActivity"></textarea>
                <mat-error id="required" *ngIf="newVisit.controls['descriptionActivity'].hasError('required')">
                    La Descripción es
                    <strong>requerida</strong>
                </mat-error>
            </mat-form-field>
        </div>


    </div>

    <div mat-dialog-actions fxLayoutAlign="end none">
        <button mat-button type="button" (click)="onDismiss()">Cancelar</button>
        <button mat-raised-button color="primary" type="submit">Guardar</button>
    </div>
</form>